(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ausmed-blog-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.tocReady === 'true') return;

      const content = root.querySelector('[data-article-content]');
      const tocList = root.querySelector('[data-toc-list]');
      if (!content || !tocList) return;

      const headings = Array.from(content.querySelectorAll('h2, h3')).filter((heading) => heading.textContent.trim().length > 0);

      if (!headings.length) {
        const card = root.querySelector('.ausmed-blog-details__toc-card');
        if (card) card.hidden = true;
        root.dataset.tocReady = 'true';
        return;
      }

      tocList.innerHTML = '';

      headings.forEach((heading, idx) => {
        const raw = heading.textContent.trim();
        const baseId =
          raw
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '')
            .trim()
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-') || `heading-${idx + 1}`;

        const id = heading.id || `article-${baseId}-${idx + 1}`;
        heading.id = id;
        heading.classList.add('ausmed-blog-details__heading');
        if (heading.tagName.toLowerCase() === 'h2') {
          heading.classList.add('ausmed-blog-details__heading--h2');
        } else if (heading.tagName.toLowerCase() === 'h3') {
          heading.classList.add('ausmed-blog-details__heading--h3');
        }

        const li = document.createElement('li');
        li.className = 'ausmed-blog-details__toc-item';

        const a = document.createElement('a');
        a.className = 'ausmed-blog-details__toc-link';
        a.href = `#${id}`;
        a.textContent = raw;

        li.appendChild(a);
        tocList.appendChild(li);
      });

      root.dataset.tocReady = 'true';
    };

    document.querySelectorAll('.ausmed-blog-details').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      const sectionRoot = event.target?.querySelector?.('.ausmed-blog-details');
      if (sectionRoot) init(sectionRoot);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ausmed-collection-description"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-ausmed-collection-description-toggle]');
    if (!toggle) return;

    const root = toggle.closest('[data-ausmed-collection-description]');
    if (!root) return;

    const content = root.querySelector('[data-ausmed-collection-description-content]');
    const toggleText = root.querySelector('[data-ausmed-collection-description-toggle-text]');
    if (!content || !toggleText) return;

    const willExpand = !content.classList.contains('is-expanded');
    if (willExpand) {
      content.classList.remove('is-collapsed');
      content.classList.add('is-expanded');
    } else {
      content.classList.remove('is-expanded');
      content.classList.add('is-collapsed');
    }

    const expandedLabel = toggleText.dataset.expandedLabel || 'Read Less';
    const collapsedLabel = toggleText.dataset.collapsedLabel || 'Read More';

    toggle.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
    toggleText.textContent = willExpand ? expandedLabel : collapsedLabel;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ausmed-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const scrollAmount = 340;
    const rootSelector = 'product-recommendations.ausmed-product-recommendations';

    function getTrack(root) {
      return root.querySelector('[data-carousel-track]');
    }

    function updateButtons(root) {
      const track = getTrack(root);
      const prevBtn = root.querySelector('[data-carousel-prev]');
      const nextBtn = root.querySelector('[data-carousel-next]');
      if (!track) return;
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (prevBtn) prevBtn.disabled = maxScroll <= 0 || track.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = maxScroll <= 0 || track.scrollLeft >= maxScroll - 1;
    }

    function bindScrollListener(root) {
      const track = getTrack(root);
      if (!track) return;
      if (track.dataset.ausmedPrScrollBound) return;
      track.dataset.ausmedPrScrollBound = '1';
      track.addEventListener(
        'scroll',
        function () {
          updateButtons(root);
        },
        { passive: true }
      );
      const ro = new ResizeObserver(function () {
        updateButtons(root);
      });
      ro.observe(track);
    }

    function initRoot(root) {
      bindScrollListener(root);
      updateButtons(root);
    }

    function scan() {
      document.querySelectorAll(rootSelector).forEach(function (root) {
        initRoot(root);
        if (root._ausmedPrObserver) {
          root._ausmedPrObserver.disconnect();
        }
        root._ausmedPrObserver = new MutationObserver(function () {
          requestAnimationFrame(function () {
            initRoot(root);
          });
        });
        root._ausmedPrObserver.observe(root, { childList: true, subtree: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', scan);

    document.addEventListener(
      'click',
      function (e) {
        const t = e.target;
        if (!t || !t.closest) return;
        const prev = t.closest('[data-carousel-prev]');
        const next = t.closest('[data-carousel-next]');
        if (!prev && !next) return;
        const root = t.closest(rootSelector);
        if (!root) return;
        const track = getTrack(root);
        if (!track) return;
        e.preventDefault();
        if (prev) track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        if (next) track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        setTimeout(function () {
          updateButtons(root);
        }, 350);
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ausmed-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.currentScript?.closest('[data-ausmed-testimonials-readmore]');
    if (!root) return;

    const labelMore = root.getAttribute('data-ausmed-testimonials-readmore-label-more') || 'Read more';
    const labelLess = root.getAttribute('data-ausmed-testimonials-readmore-label-less') || 'Read less';

    const isClamped = (quote, card) => {
      const clone = quote.cloneNode(true);
      clone.style.display = 'block';
      clone.style.position = 'absolute';
      clone.style.visibility = 'hidden';
      clone.style.pointerEvents = 'none';
      clone.style.height = 'auto';
      clone.style.maxHeight = 'none';
      clone.style.overflow = 'visible';
      clone.style.webkitLineClamp = 'unset';
      clone.style.lineClamp = 'unset';
      clone.style.webkitBoxOrient = 'initial';
      clone.style.whiteSpace = 'normal';
      clone.style.width = `${quote.clientWidth || quote.getBoundingClientRect().width}px`;
      card.appendChild(clone);
      const fullHeight = clone.scrollHeight;
      clone.remove();
      return fullHeight - quote.clientHeight > 1;
    };

    const updateOverflow = () => {
      const cards = root.querySelectorAll('.ausmed-testimonials__card');
      cards.forEach((card) => {
        const quote = card.querySelector('.ausmed-testimonials__quote');
        const btn = card.querySelector('[data-ausmed-testimonials-readmore-toggle]');
        if (!quote || !btn) return;

        if (card.classList.contains('is-expanded')) {
          btn.hidden = false;
          btn.textContent = labelLess;
          btn.setAttribute('aria-expanded', 'true');
          return;
        }

        btn.textContent = labelMore;
        btn.setAttribute('aria-expanded', 'false');

        btn.hidden = !isClamped(quote, card);
      });
    };

    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-ausmed-testimonials-readmore-toggle]');
      if (!btn) return;
      const card = btn.closest('.ausmed-testimonials__card');
      if (!card) return;

      const isExpanded = card.classList.toggle('is-expanded');
      btn.textContent = isExpanded ? labelLess : labelMore;
      btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

      requestAnimationFrame(updateOverflow);
    });

    const onResize = () => requestAnimationFrame(updateOverflow);
    window.addEventListener('resize', onResize, { passive: true });

    requestAnimationFrame(updateOverflow);
    setTimeout(updateOverflow, 100);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-brand-main-description-toggle]');
    if (!toggle) return;
    const root = toggle.closest('[data-brand-main-description]');
    if (!root) return;
    const content = root.querySelector('[data-brand-main-description-content]');
    const toggleText = root.querySelector('[data-brand-main-description-toggle-text]');
    if (!content || !toggleText) return;

    const willExpand = !content.classList.contains('is-expanded');
    if (willExpand) {
      content.classList.remove('is-collapsed');
      content.classList.add('is-expanded');
    } else {
      content.classList.remove('is-expanded');
      content.classList.add('is-collapsed');
    }
    toggle.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
    toggleText.textContent = willExpand ? 'Read less' : 'Read more';
  });

  } catch(e) { console.error(e); }
})();
})();
